var map = {
	"./avi.png": "656f",
	"./doc.png": "5943",
	"./jpg.png": "9b67",
	"./mov.png": "e87c",
	"./mp3.png": "2bce",
	"./mpg.png": "0704",
	"./pdf.png": "92d4",
	"./png.png": "82f4",
	"./txt.png": "dae4",
	"./xls.png": "d210"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "138a";